import img1 from '../../../assets/img/product-image/product1.png'
import img2 from '../../../assets/img/product-image/product2.png'
import img3 from '../../../assets/img/product-image/product3.png'
import img4 from '../../../assets/img/product-image/product4.png'
import img5 from '../../../assets/img/product-image/product5.png'
import img6 from '../../../assets/img/product-image/product6.png'
import img7 from '../../../assets/img/product-image/product7.png'
import img8 from '../../../assets/img/product-image/product8.png'
import img9 from '../../../assets/img/product-image/product9.png'
import img10 from '../../../assets/img/product-image/product10.png'
import img11 from '../../../assets/img/product-image/product11.png'
import img12 from '../../../assets/img/product-image/product12.png'
import img13 from '../../../assets/img/product-image/product13.png'
import img14 from '../../../assets/img/product-image/product14.png'
import img15 from '../../../assets/img/product-image/product15.png'

export const ProductData = [
    {   
        id:1,
        top_tital:"New",
        class:"new",
        main_img: img1,
        hover_img: img2,
        product_title: "Blue Dress For Woman",
        price: "$38.00",
        view: 20,
        button: "Add To Cart",
        para:`Vivamus suscipit tortor eget felis porttitor volutpat. Lorem ipsum dolor sit amet, consectetur adipiscing elit.
         Proin eget tortor risus. Nulla porttitor accumsan tincidunt. Pellentesque in ipsum id orci porta dapibus.`
       
    },
    {
        id:2,
        top_tital:"hot",
        class:"hot",
        main_img: img3,
        hover_img: img4,
        product_title: "Woman Full Sliv Dresss",
        price: "$39.00",
        view: 20,
        button: "Add To Cart",
        para:`Vivamus suscipit tortor eget felis porttitor volutpat. Lorem ipsum dolor sit amet, consectetur adipiscing elit.
        Proin eget tortor risus. Nulla porttitor accumsan tincidunt. Pellentesque in ipsum id orci porta dapibus.`
       
    },
    {
        id:3,
        top_tital:"New",
        class:"new",
        main_img: img5,
        hover_img: img6,
        product_title: "Black T-Shirt For Woman",
        price: "$18.00",
        view: 20,
        button: "Add To Cart",
        para:`Vivamus suscipit tortor eget felis porttitor volutpat. Lorem ipsum dolor sit amet, consectetur adipiscing elit.
        Proin eget tortor risus. Nulla porttitor accumsan tincidunt. Pellentesque in ipsum id orci porta dapibus.`
       
    },
    {
        id:4,
        top_tital:"hot",
        class:"hot",
        main_img: img7,
        hover_img: img8,
        product_title: "Blue Dress For Woman",
        price: "$38.00",
        view: 20,
        button: "Add To Cart",
        para:`Vivamus suscipit tortor eget felis porttitor volutpat. Lorem ipsum dolor sit amet, consectetur adipiscing elit.
        Proin eget tortor risus. Nulla porttitor accumsan tincidunt. Pellentesque in ipsum id orci porta dapibus.`
       
    },
    {
        id:5,
        top_tital:"New",
        class:"new",
        main_img: img9,
        hover_img: img10,
        product_title: "Woman Full Sliv Dresss",
        price: "$88.00",
        view: 20,
        button: "Add To Cart",
        para:`Vivamus suscipit tortor eget felis porttitor volutpat. Lorem ipsum dolor sit amet, consectetur adipiscing elit.
        Proin eget tortor risus. Nulla porttitor accumsan tincidunt. Pellentesque in ipsum id orci porta dapibus.`
       
    },
    {
        id:6,
        top_tital:"hot",
        class:"hot",
        main_img: img11,
        hover_img: img12,
        product_title: "Blue Dress For Woman",
        price: "$48.00",
        view: 20,
        button: "Add To Cart",
        para:`Vivamus suscipit tortor eget felis porttitor volutpat. Lorem ipsum dolor sit amet, consectetur adipiscing elit.
        Proin eget tortor risus. Nulla porttitor accumsan tincidunt. Pellentesque in ipsum id orci porta dapibus.`
       
    },
    {
        id:7,
        top_tital:"New",
        class:"new",
        main_img: img13,
        hover_img: img14,
        product_title: "Black T-Shirt For Woman",
        price: "$34.00",
        view: 20,
        button: "Add To Cart",
        para:`Vivamus suscipit tortor eget felis porttitor volutpat. Lorem ipsum dolor sit amet, consectetur adipiscing elit.
        Proin eget tortor risus. Nulla porttitor accumsan tincidunt. Pellentesque in ipsum id orci porta dapibus.`
       
    },
    {
        id:8,
        top_tital:"hot",
        class:"hot",
        main_img: img15,
        hover_img: img1,
        product_title: "Blue Dress For Woman",
        price: "$38.00",
        view: 20,
        button: "Add To Cart",
        para:`Vivamus suscipit tortor eget felis porttitor volutpat. Lorem ipsum dolor sit amet, consectetur adipiscing elit.
        Proin eget tortor risus. Nulla porttitor accumsan tincidunt. Pellentesque in ipsum id orci porta dapibus.`
       
    },
    {
        id:9,
        top_tital:"New",
        class:"new",
        main_img: img1,
        hover_img: img13,
        product_title: "Black T-Shirt For Woman",
        price: "$31.00",
        view: 20,
        button: "Add To Cart",
        para:`Vivamus suscipit tortor eget felis porttitor volutpat. Lorem ipsum dolor sit amet, consectetur adipiscing elit.
        Proin eget tortor risus. Nulla porttitor accumsan tincidunt. Pellentesque in ipsum id orci porta dapibus.`
       
    },
    {
        id:10,
        top_tital:"hot",
        class:"hot",
        main_img: img2,
        hover_img: img12,
        product_title: "Woman Full Sliv Dresss",
        price: "$38.00",
        view: 20,
        button: "Add To Cart",
        para:`Vivamus suscipit tortor eget felis porttitor volutpat. Lorem ipsum dolor sit amet, consectetur adipiscing elit.
        Proin eget tortor risus. Nulla porttitor accumsan tincidunt. Pellentesque in ipsum id orci porta dapibus.`
       
    },
    {
        id:11,
        top_tital:"New",
        class:"new",
        main_img: img3,
        hover_img: img11,
        product_title: "Blue Dress For Woman",
        price: "$56.00",
        view: 20,
        button: "Add To Cart",
        para:`Vivamus suscipit tortor eget felis porttitor volutpat. Lorem ipsum dolor sit amet, consectetur adipiscing elit.
        Proin eget tortor risus. Nulla porttitor accumsan tincidunt. Pellentesque in ipsum id orci porta dapibus.`
       
    },
    {
        id:12,
        top_tital:"hot",
        class:"hot",
        main_img: img4,
        hover_img: img10,
        product_title: "Blue Dress For Woman",
        price: "$35.00",
        view: 20,
        button: "Add To Cart",
        para:`Vivamus suscipit tortor eget felis porttitor volutpat. Lorem ipsum dolor sit amet, consectetur adipiscing elit.
        Proin eget tortor risus. Nulla porttitor accumsan tincidunt. Pellentesque in ipsum id orci porta dapibus.`
       
    },
    {
        id:13,
        top_tital:"New",
        class:"new",
        main_img: img5,
        hover_img: img9,
        product_title: "Woman Full Sliv Dresss",
        price: "$28.00",
        view: 20,
        button: "Add To Cart",
        para:`Vivamus suscipit tortor eget felis porttitor volutpat. Lorem ipsum dolor sit amet, consectetur adipiscing elit.
        Proin eget tortor risus. Nulla porttitor accumsan tincidunt. Pellentesque in ipsum id orci porta dapibus.`
       
    },
    {
        id:14,
        top_tital:"hot",
        class:"hot",
        main_img: img6,
        hover_img: img8,
        product_title: "Blue Dress For Woman",
        price: "$68.00",
        view: 20,
        button: "Add To Cart",
        para:`Vivamus suscipit tortor eget felis porttitor volutpat. Lorem ipsum dolor sit amet, consectetur adipiscing elit.
        Proin eget tortor risus. Nulla porttitor accumsan tincidunt. Pellentesque in ipsum id orci porta dapibus.`
       
    },
    {
        id:15,
        top_tital:"New",
        class:"new",
        main_img: img5,
        hover_img: img7,
        product_title: "Woman Full Sliv Dresss",
        price: "$58.00",
        view: 20,
        button: "Add To Cart",
        para:`Vivamus suscipit tortor eget felis porttitor volutpat. Lorem ipsum dolor sit amet, consectetur adipiscing elit.
        Proin eget tortor risus. Nulla porttitor accumsan tincidunt. Pellentesque in ipsum id orci porta dapibus.`  
    }
]